import React, { useState } from "react";
import {
  AiOutlineMessage,
  AiOutlineUser,
  AiOutlineMail,
  AiOutlinePhone,
} from "react-icons/ai";
import FeedStyle from "./FeedChildStyles";
const FeedbackChild = ({ data, read_callback, read }) => {
  const [view, setView] = useState(false);
  const [bool, setFalse] = useState(false);

  return (
    <FeedStyle className={`${bool ? "deactivated" : ""} `}>
      {[data].map((v, i) => (
        <div className={`feedcard ${bool ? "deactivated" : ""}`} key={i}>
          <div className="d-flex justify-content-between">
            <div className="left">
              <h4 className="text-info">
                {" "}
                <AiOutlineUser /> {v.fullName}
              </h4>
              <a href={`mailto:${v.email}`} className="fw-bold">
                <AiOutlineMail />
                {v.email}
              </a>
              <br />
              <a href={`tel:${v.phoneNumber}`} className="fw-bold">
                <AiOutlinePhone />
                {v.phoneNumber}
              </a>
            </div>
            <div className="right">
              <button
                className={`btn btn-outline-primary ${
                  read ? "d-none" : "d-inline-block"
                }`}
                onClick={() => {
                  read_callback(v.id);
                  setFalse(true);
                }}
              >
                Hide
              </button>
              <button
                className="btn btn-outline-info"
                onClick={() => setView(!view)}
              >
                <span>
                  <AiOutlineMessage />
                </span>
                <span className="ms-1 mb-0"> View Message</span>
              </button>
            </div>
          </div>
          <div
            className={`py-2 mt-2 border-2 border-top ${
              view ? "d-block" : "d-none"
            }`}
          >
            <p>{v.description}</p>
          </div>
        </div>
      ))}
    </FeedStyle>
  );
};

export default FeedbackChild;



// WEBPACK FOOTER //
// ./src/Components/Feedback/index.js